import { useTranslation } from 'next-i18next'
import { useLocalisedContent } from 'services/hooks/use-localised-data'
import { type Transifex } from 'types'

/**
 * When sourcing user avatars from Twitter you want the 400 version.
 * The link will look like this
 * https://pbs.twimg.com/profile_images/1449688459090747394/CmC1pLkT_400x400.jpg
 * You can get the two ids by checking the network request for the version of the avatar twitter is showing
 * or open the small one and append 400x400 to it
 * */

const evnsio: Record<Transifex.Languages, string> = {
    en: 'https://x.com/evnsio/status/1620177436574105606',
    'zh-TW': 'https://x.com/littlegoodjack/status/1321039730830536706',
    fi: 'https://x.com/Akikuvaa/status/1349006207235878914',
    nl: 'https://x.com/yesimtireddd/status/1755574267406606709',
    sv: 'https://x.com/NoCodeWizard/status/1715028646048522379',
    tr: 'https://x.com/burak_tamac/status/1756748107201527971',
    ko: 'https://x.com/ppyagdaegaligw1/status/1671519116140724224',
    ja: 'https://x.com/galliano/status/1777555048161251513',
    'zh-CN': 'https://x.com/dytes/status/1555197724982915073',
    ru: 'https://x.com/maksaich/status/1534839071108911112',
    it: 'https://x.com/gianmix/status/1566697117716041728',
    'pt-BR': 'https://x.com/perimcomm/status/1549267588542337024',
    es: 'https://x.com/MoureDev/status/1744472092383310050',
    da: 'https://x.com/matibold/status/1748254726225858625',
    cs: 'https://x.com/Svrdlin/status/1375844179239112708',
    fr: 'https://x.com/NdyeAbsaGningue/status/1455827338353070082',
    de: 'https://x.com/momentaufnahmen/status/1355105767628693504',
    nb: 'https://x.com/MarkedsOptimist/status/1496462704940355591',
    pl: 'https://x.com/JavaDevMatt/status/1064788376308588545',
}

const notJulien: Record<Transifex.Languages, string> = {
    en: 'https://x.com/not_julien/status/1627416570149363712',
    'zh-TW': 'https://x.com/kikinote123/status/1541245873359036416',
    fi: 'https://x.com/erikastrandberg/status/1422578859267006467',
    nl: 'https://x.com/wuyts_l/status/1661302422801719299',
    sv: 'https://x.com/Aldenfalk/status/1298554216450056192',
    tr: 'https://x.com/ozi_dev/status/1741800914912944300',
    ko: 'https://x.com/horse_sensei/status/1774267572684525804',
    ja: 'https://x.com/kako_yama_ika/status/1777200206670688446',
    'zh-CN': 'https://x.com/coolXiao/status/1439057126756782087',
    ru: 'https://x.com/ignattru/status/1525381195684528128',
    it: 'https://x.com/saraeinziel/status/1458745018684948485',
    'pt-BR': 'https://x.com/moacirmoda/status/1777126183664034249',
    es: 'https://x.com/carlaconwifi/status/1666161111652024322',
    da: 'https://x.com/Hverdagshelten/status/1736768133224976806',
    cs: 'https://x.com/kleinptr/status/1261706633215971336',
    fr: 'https://x.com/NicolasRoland/status/1491456924029960193',
    de: 'https://x.com/MattisFrommer/status/1562411348956430336',
    nb: 'https://x.com/bagchaser_nr1/status/1482023685087236098',
    pl: 'https://x.com/michal_osinski/status/1767836210456645923',
}

const sascha: Record<Transifex.Languages, string> = {
    en: 'https://x.com/saschafrommars/status/1613534410992717825',
    'zh-TW': 'https://x.com/shouldwang/status/1086830524130160641',
    fi: 'https://x.com/markosuomi/status/1678441079824056321',
    nl: 'https://x.com/SBSTROP/status/1640085258715398145',
    sv: 'https://x.com/olofhaglund/status/1496870479625392129',
    tr: 'https://x.com/bmutluseferoglu/status/1594047992151310336',
    ko: 'https://x.com/_jeyraof/status/1762672251256938926',
    ja: 'https://x.com/KanemitsuYuuki/status/1777144674421281055',
    'zh-CN': 'https://x.com/Megabits_mzq/status/1770691352642121813',
    ru: 'https://x.com/it_heisenberg/status/1517100805429551104',
    it: 'https://x.com/valeminer/status/1524706196426571776',
    'pt-BR': 'https://x.com/paulovito56/status/1760725019808944619',
    es: 'https://x.com/gamusino/status/1759526396433449231',
    da: 'https://x.com/SaschaFromMars/status/1613534410992717825',
    cs: 'https://x.com/tomaszaruba/status/1313720740051591168',
    fr: 'https://x.com/Samurai9723/status/1293159447523667974',
    de: 'https://x.com/der_holzii/status/1462174126219710474',
    nb: 'https://x.com/MindAK_/status/1481974386865418240',
    pl: 'https://x.com/uwteam/status/1750090878042206522',
}

const moinak: Record<Transifex.Languages, string> = {
    en: 'https://x.com/iammoinak/status/1622464641753567233',
    'zh-TW': 'https://x.com/Irena_Yuan/status/1464320195577593856',
    fi: 'https://x.com/kaikkijotka/status/1759371261283610786',
    nl: 'https://x.com/erwinvanwijk/status/1596132580600020996',
    sv: 'https://x.com/stroemberg/status/1572807591700439040',
    tr: 'https://x.com/0xferit/status/1751264926604177787',
    ko: 'https://x.com/hyunbinseo97/status/1757598033221730429',
    ja: 'https://x.com/JunyaSumita/status/1608980444791607297',
    'zh-CN': 'https://x.com/iamshaynez/status/1767811865449754811',
    ru: 'https://x.com/senklers/status/1775461103088111879',
    it: 'https://x.com/steotriumph/status/1575531971853393924',
    'pt-BR': 'https://x.com/segundoadv/status/1759221507220250704',
    es: 'https://x.com/LaAgendadeDiana/status/1756001260946280888',
    da: 'https://x.com/nissarup/status/1397473223411896323',
    cs: 'https://x.com/davous267/status/1214664311983017988',
    fr: 'https://x.com/copykarter/status/1484474062160150530',
    de: 'https://x.com/thomassymalla/status/1358721898130112515',
    nb: 'https://x.com/TheNewCompanyNO/status/1311908842213646337',
    pl: 'https://x.com/dfordesign/status/1684857049354526720',
}

const tweetData = {
    evnsio,
    notJulien,
    sascha,
    moinak,
}

type TweetName = keyof typeof tweetData

function nameMap(name: TweetName): string {
    switch (name) {
        case 'notJulien':
            return 'not_julien'
        case 'sascha':
            return 'saschafrommars'
        case 'moinak':
            return 'iammoinak'
        default:
            return name
    }
}

export function useLocalisedTweetInfo(name: TweetName) {
    const data = tweetData[name]
    const link = useLocalisedContent(data)
    const {
        i18n: { language = 'en' },
    } = useTranslation('common')

    return {
        avatar: `${process.env.NEXT_PUBLIC_BASE_URL}/static/teams/twitter_avatars/${nameMap(name)}-${language}.jpg`,
        link,
    }
}
